import { createSlice } from "@reduxjs/toolkit";

interface TeacherExampleState {
  value: number;
}

const initialState: TeacherExampleState = {
  value: 0,
};

/** @deprecated remove this once we have some actual teacher state to manage */
const teacherExampleSlice = createSlice({
  name: "teacherExample",
  initialState,
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    incrementByAmount: (state, action: { payload: number }) => {
      state.value += action.payload;
    },
  },
});

export const { increment, decrement, incrementByAmount } =
  teacherExampleSlice.actions;
export default teacherExampleSlice.reducer;
